var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cp-home" },
    [
      _vm._m(0),
      _c("div", { staticClass: "list-links" }, [
        _vm._m(1),
        _vm._m(2),
        _c(
          "a",
          {
            staticClass: "link3 ani-card",
            on: {
              click: function($event) {
                _vm.showVideo = 1
              }
            }
          },
          [_c("b", [_vm._v("了解维拉")])]
        )
      ]),
      _c("div", { staticClass: "partners" }, [
        _c("div", { staticClass: "pp" }, [_vm._v("合作伙伴")]),
        _c("div", { staticClass: "logo-list" }, [
          _c(
            "ul",
            { staticClass: "ul1" },
            [
              _vm._l(_vm.partners1, function(n) {
                return _c("li", {
                  style: {
                    backgroundImage: "url(static/images/partners/" + n + ".png)"
                  }
                })
              }),
              _vm._l(_vm.partners1, function(n) {
                return _c("li", {
                  style: {
                    backgroundImage: "url(static/images/partners/" + n + ".png)"
                  }
                })
              })
            ],
            2
          ),
          _c(
            "ul",
            { staticClass: "ul2", staticStyle: { "margin-left": "-50px" } },
            [
              _vm._l(_vm.partners2, function(n) {
                return _c("li", {
                  style: {
                    backgroundImage: "url(static/images/partners/" + n + ".png)"
                  }
                })
              }),
              _vm._l(_vm.partners2, function(n) {
                return _c("li", {
                  style: {
                    backgroundImage: "url(static/images/partners/" + n + ".png)"
                  }
                })
              })
            ],
            2
          )
        ])
      ]),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showVideo,
                expression: "showVideo"
              }
            ],
            staticClass: "video-wrap"
          },
          [
            _c("div", { staticClass: "mask", on: { click: _vm.closeVideo } }),
            _c(
              "div",
              { staticClass: "btn-close", on: { click: _vm.closeVideo } },
              [_vm._v("+")]
            ),
            _vm.showVideo
              ? _c("iframe", {
                  attrs: {
                    frameborder: "0",
                    allowfullscreen: "allowfullscreen",
                    src: "https://v.qq.com/iframe/player.html?vid=r0538txqcoz"
                  }
                })
              : _vm._e()
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("div", { attrs: { id: "iSlider-wrapper" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "link1 ani-card",
        attrs: { href: "/#/news", target: "_black" }
      },
      [_c("b", [_vm._v("新闻动态")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "link2 ani-card",
        attrs: { href: "/#/robot3/design", target: "_black" }
      },
      [_c("b", [_vm._v("颜值至上")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a4bed13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a4bed13","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = ZfXq
// module chunks = 0